import { render, staticRenderFns } from "./DetailTab.vue?vue&type=template&id=06d8610f&scoped=true"
import script from "./DetailTab.vue?vue&type=script&lang=js"
export * from "./DetailTab.vue?vue&type=script&lang=js"
import style0 from "./DetailTab.vue?vue&type=style&index=0&id=06d8610f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8610f",
  null
  
)

export default component.exports